export const CAMPAIGNS_LOADING = 'DOCUMENT_CAMPAIGNS_LOADING';
export const CAMPAIGNS_LOADED = 'DOCUMENT_CAMPAIGNS_LOADED';
export const CAMPAIGNS_ERROR = 'DOCUMENT_CAMPAIGNS_ERROR';
